import { render, staticRenderFns } from "./CarResultsSkeleton.vue?vue&type=template&id=1bf03f58&scoped=true&"
import script from "./CarResultsSkeleton.vue?vue&type=script&lang=js&"
export * from "./CarResultsSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CarResultsSkeleton.vue?vue&type=style&index=0&id=1bf03f58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf03f58",
  null
  
)

export default component.exports